module.exports = __webpack_public_path__ + "static/img/retail_img_2_cn.909b792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/retail_img_2_cn.png
// module id = qx9B
// module chunks = 0